import React from 'react'
import { getArticleDetail_articleGraph_detail } from '~/graphqls/types'
import { ArticleShare } from './ArticleShare'
import dayjs from 'dayjs'
import classNames from 'classnames'

export const ArticleHeader: React.FC<{
  article: getArticleDetail_articleGraph_detail
  style?: React.CSSProperties
  className?: string
}> = props => {
  const { article, style, className } = props
  return (
    <div style={style} className={classNames('relative', { className })}>
      <div className="text-2xl text-neutral-200 font-semibold line-clamp-2">
        {article?.post?.title}
      </div>
      <div className="py-4 border-b border-neutral-600 text-sm text-neutral-400 font-normal ">
        <div className="line-clamp-2 ">
          {article?.extra?.copyrightInfo?.originalName}
        </div>
        <div className="mt-2 ">
          {article?.post?.postDate &&
            dayjs(article?.post?.postDate * 1000).format('YYYY-MM-DD HH:mm:ss')}
        </div>
      </div>
      <div className="absolute right-0 bottom-4">
        {article?.post?.postUrl && (
          <ArticleShare
            title={article?.post?.title || ''}
            shareUrl={article?.post?.postUrl || ''}
          />
        )}
      </div>
    </div>
  )
}
